<template>

	<section class="subcategorylink">

<!--     <div class="container">
			<div class="subcategorylink__buttons">
		        <div @click="previous()" class="flickity__prev">
		           <svg viewBox="0 0 448 512">
		              <path d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"></path>
		           </svg>
		        </div>
		        <div @click="next()" class="flickity__next">
		           <svg viewBox="0 0 448 512">
		              <path d="M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"></path>
		           </svg>
		        </div>
	    	</div>
    	</div> -->

      <div class="subcategorylink__swipe" v-bind:class="{ 'subcategorylink__swipe--active': isSwipeActive }">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M115.2 70.4v121.792c-12.189-5.437-27.01-9.791-44.8-9.791C29.922 182.4 0 214.687 0 256c0 48.546 53.853 57.8 76.315 71.683 17.761 11.062 57.069 42.869 67.144 60.919C134.194 394.208 128 404.38 128 416v64c0 17.673 14.327 32 32 32h224c17.673 0 32-14.327 32-32v-64c0-9.167-3.861-17.428-10.038-23.262C413.719 358.089 448 321.746 448 267.636V244.4c0-59.606-36.084-90.256-85.87-88.631-17.108-14.3-42.155-21.279-65.494-16.635-11.856-7.229-25.395-11.348-39.582-11.885a92.713 92.713 0 0 0-1.054-.033V70.4C256 32.063 224.084 0 185.6 0c-38.161 0-70.4 32.77-70.4 70.4zM160 480v-64h224v64H160zm64-409.6v99.301c16.003-14.004 46.718-15.726 66.6 5.4 21.431-12.247 49.771-1.841 58.5 14.1 42.685-7.116 66.9 10.993 66.9 55.201v23.236c0 44.337-31.267 76.684-40.861 116.364H176.462c-10.706-29.835-59.818-68.904-83.262-83.5C67.686 284.704 32 280 32 256s16-41.6 38.4-41.6c38.4 0 57.9 28.8 76.8 28.8V70.4c0-20.1 18-38.4 38.4-38.4 20.7 0 38.4 17.7 38.4 38.4zM352 428c11.046 0 20 8.954 20 20s-8.954 20-20 20-20-8.954-20-20 8.954-20 20-20z" class=""></path>
        </svg>
        <span>Swipe to view more</span>
      </div>

      <flickity ref="flickity" :options="flickityOptions">
      	<div class="subcategorylink__item" v-for="act in activities">
      		<a @click='navigate(act)'>
	      		<div class="subcategorylink__img" v-bind:style="{ background: 'url(' + act.activityThumb + ')' + 'no-repeat center center' }"></div>
	      		<div class="subcategorylink__over"></div>
	      		<div class="subcategorylink__content">
	      			<h4>{{ act.activityTitle }}</h4>
	      			<!-- <sub>{{ act.activityOperator }}</sub> -->
	      		</div>
      		</a>
      	</div>
      </flickity>
	</section>

</template>

<script>

	import Flickity from 'vue-flickity';

   	export default {
      	name: 'HomeScreenInfo',
      	props: ['activities'],
      	components: {
         	Flickity
      	},

      	data() {
         	return {
            	flickityOptions: {
               		fullscreen: true,
               		prevNextButtons: false,
               		cellAlign: 'left',
               		contain: true,
               		pauseAutoPlayOnHover: false,
               		initialIndex: 0,
               		prevNextButtons: false,
               		pageDots: false
            	},
              isSwipeActive: false
         	}
      	},
        created() {
          this.isSwipeActive = this.activities.length > 3
          if (this.isSwipeActive) {
            this.removeSwipe()
          }
        },
      	methods: {
         	next() {
            	this.$refs.flickity.next();
         	},

         	previous() {
            	this.$refs.flickity.previous();
         	},
         
          navigate (act) {
            this.$router.currentRoute.params.actUrlSegment = act.actUrlSegment
            this.$router.push({ name: 'activity', params: this.$router.currentRoute.params })
          },

          removeSwipe () {
            window.setTimeout(() => {
              this.isSwipeActive = false
            }, 4200)
          }
        }
      }


</script>
